export class ResultDto<T> {
  data: T | undefined;
  error: string | undefined;

  private constructor(data?: T, error?: string) {
    this.data = data;
    this.error = error;
  }

  static success<T>(data: T): ResultDto<T> {
    return new ResultDto(data);
  }

  static error(error: string) {
    return new ResultDto(undefined, error);
  }
}
